import {
    VOUCHER_DOWNLOAD_FAILURE,
} from 'store/actions/types';

export const downloadVoucherFailure = (error) => {
    return {
        type: VOUCHER_DOWNLOAD_FAILURE,
        error: error,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/voucherActions.js